<template>
<div>
  <v-tooltip top>
    <template v-slot:activator={on}>
      <v-btn
          v-on="on"
          id="botaoGerarQRCode"
          :outlined="outlined"
          :disabled="disabled"
          icon
          :color="color"
          @click="$emit('modalQRCode')">
        <v-icon>mdi-qrcode</v-icon>
      </v-btn>
    </template>
    Gerar QRCode da ficha do paciente
  </v-tooltip>
</div>
</template>

<script>
export default {
    name: 'BotaoGerarQRCode',
    props:{
        disabled: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: 'white'
        }
    }
}
</script>

<style scoped lang="stylus">

</style>
